import { PostCallFeedbackState } from './types';

export const INITIAL_POST_CALL_FEEDBACK_STATE: PostCallFeedbackState = {
  isAccurateSummary: null,
  summaryAccuracyIssues: [],
  summaryAccuracyFeedback: undefined,
  isAccurateTranscription: null,
  accuracyIssues: [],
  accuracyFeedback: undefined,
  isAccurateSuggestion: null,
  suggestionAccuracyIssues: [],
  suggestionAccuracyFeedback: undefined,
};
